import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";
import { PageAlert } from "capitalrx-components";
import { TransmissionTypes } from "@/types";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { transmissionManualActions } from "@/App/actions";

function* transmissionManual(payload: TransmissionTypes.TransmissionData): Generator {
  return yield apiService({
    url: "/transmission/manual",
    method: "POST",
    data: payload,
  });
}

export function* transmissionManualWorker(action: ReturnType<typeof transmissionManualActions.submitTransmissionManual>): SagaIterator {
  const { payload, formName } = action;
  const { showPageAlert } = PageAlert;
  const { submitTransmissionManualResult } = transmissionManualActions;

  try {
    yield put(startSubmit(formName));
    const result = yield call(transmissionManual, payload);

    yield put(submitTransmissionManualResult(result));
    yield put(stopSubmit(formName));
  } catch (error) {
    const {
      data: { field_error_messages = "", message = "Processing Manual Claim failed." } = {},
    } = error || {};

    yield put(showPageAlert({ show: true, type: "error", message: message }));
    yield put(stopSubmit(formName, field_error_messages));
  }
}

export default function* transmissionManualWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.SUBMIT_TRANSMISSION_MANUAL, transmissionManualWorker);
}
